export default __webpack_public_path__ + "static/floor3-slide-6-7da666450c122108db56910350bd62e5.jpg";